export const CLIENT_CODE_STORAGE_KEY = 'client-code';
